import { useMutation } from '@tanstack/react-query';
import { ForgotPasswordService } from '../services/ForgotPasswordService';
import type {
  ISendRecoveryCodeRequest,
  TSendRecoveryCodeResponse,
} from '../types/ForgotPassword';

export const useSendRecoveryCode = () =>
  useMutation<TSendRecoveryCodeResponse, unknown, ISendRecoveryCodeRequest>({
    mutationFn: (payload) => ForgotPasswordService.sendRecoveryCode(payload),
  });
